import React, { useEffect, useState } from 'react';
import '../../common/css/noticeList.css';

function FAQ() {
    const [NoticeStatue, setNoticeStatue] = useState('');

    const checkNoticeStatus = () => {
        const status = window.location.search.split('=')[1];

        if (status === 'valid') {
            setNoticeStatue(status);
        } else if (status === 'invalid') {
            setNoticeStatue(status);
        }
    };

    useEffect(() => {
        checkNoticeStatus();
    }, []);

    return (
        <div id='contents' className='notice-contents'>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>공지사항</div>
                    <div>이벤트/프로모션</div>
                </div>
            </div>
            <div class='page_hgroup'>
                <h2 class='title'>이벤트/프로모션</h2>
            </div>
            <div class='event'>
                <div class='event_tab_box'>
                    <ul class='event_tab'>
                        <li className={NoticeStatue === 'valid' ? 'on' : ''}>
                            <a href='/notice/event?status=valid'>진행 중 이벤트</a>
                        </li>
                        <li className={NoticeStatue === 'invalid' ? 'on' : ''}>
                            <a href='/notice/event?status=invalid'>지난 이벤트</a>
                        </li>
                    </ul>
                    {/* <div class='search_box event_search_box'>
                        <input
                            type='text'
                            id='ss'
                            name='ss'
                            class='search'
                            placeholder='검색어를 입력하세요'
                        />
                        <input type='submit' class='button' value='검색' />
                    </div> */}
                </div>

                <div class='event_cont_box'>
                    <div class='on'>
                        <ul class='event_cont_list'>
                            <li class='search_result'>
                                <div class='result_none'>
                                    <p>현재 진행중인 이벤트가 없습니다.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FAQ;
